var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0L40.4263 29.7182C40.5039 35.1287 44.8713 39.4961 50.2818 39.5737L80 40L50.2818 40.4263C44.8713 40.5039 40.5039 44.8713 40.4263 50.2818L40 80L39.5737 50.2818C39.4961 44.8713 35.1287 40.5039 29.7182 40.4263L0 40L29.7182 39.5737C35.1287 39.4961 39.4961 35.1287 39.5737 29.7182L40 0Z",
    fill: "#E2C2D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPink);
export default __webpack_public_path__ + "static/media/star-pink.96691b56fe9287da40d20fb0472eeea1.svg";
export { ForwardRef as ReactComponent };